import React from 'react';
import BartendersPage from './BartendersPage';

export default function OwnerBrowseBartendersPage() {
  return <BartendersPage ownerMode />;
}
